module.exports = __webpack_public_path__ + "static/img/gongsijianjie_03.e7e37e7c.jpg";